import _ from "lodash";

export const stateAbbreviations = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  "District of Columbia": "DC",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Puerto Rico": "PR",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

export const states = Object.keys(stateAbbreviations);

export const statesList = states.map((s) => {
  return { name: s, id: stateAbbreviations[s] };
});

export const paymentOptions = [
  { name: "Commission payable to me", id: "me" },
  { name: "Make payable to my corporation/LLC", id: "corporation" },
  { name: "Make payment to my LOA/AOC", id: "upline" },
  { name: "Pay same as current contract", id: "current" },
];

export const paymentLabels = _(paymentOptions)
  .keyBy("id")
  .mapValues("name")
  .value();

export const gaCarrierPaymentUnitOptions = [
  { name: "$", id: "dollar" },
  { name: "%", id: "percent" }
];

export const gaStatusOptions = [
  { name: "In Connect", id: "complete" },
  { name: "Denied", id: "denied" },
  { name: "Submitted", id: "submitted" },
];

export  const contractStatusOptions = [
    { name: "Submitted", id: "submitted" },
    { name: "Closed", id: "closed" },
    { name: "In Connect", id: "complete" },
  ];

export const contractStatusLabels = _(contractStatusOptions)
  .keyBy("id")
  .mapValues("name")
  .value();

  export const gaApprovalOptions = [
    { name: "Approved", id: "approved" },
    { name: "Denied", id: "denied" },
    { name: "Pending", id: "pending" },
  ];

export const gaApprovalLabels = _(gaApprovalOptions)
  .keyBy("id")
  .mapValues("name")
  .value();

export const carrierOptions = [
  { name: "New Individual Contract", id: "new" },
  { name: "New Corporate Contract", id: "corp" },
  { name: "Transfer W/ Release", id: "transferWithRelease" },
  { name: "Transfer W/O Release", id: "transferWithoutRelease" },
];

export const carrierTypeOptions = [
  { name: "New", id: "New" },
  { name: "Renewal", id: "Renewal" },
];

const productTypes = ["Health", "Life"];

export const productTypeOptions = productTypes.map((p) => {
  return { name: p, id: p };
});

// #18 — new agent (first time with Applied GA) vs current agent requesting a carrier.
export const requestTypeOptions = [
  { id: "new-agent", name: "I'm a new agent" },
  { id: "existing-agent", name: "I'm a current agent requesting a carrier" },
];

export const requestTypeLabels = _(requestTypeOptions)
  .keyBy("id")
  .mapValues("name")
  .value();

// Compact labels for admin tables/edit views.
export const requestTypeAdminLabels = {
  "new-agent": "New Agent",
  "existing-agent": "Existing Agent",
};

export const requestTypeAdminOptions = [
  { id: "new-agent", name: "New Agent" },
  { id: "existing-agent", name: "Existing Agent" },
];

export const roleOptions = [
  { id: "agency", name: "Agency Admin" },
  { id: "admin", name: "Admin" },
  { id: "lite-admin", name: "Lite Admin" },
  { id: "readonly", name: "Read-Only" },
  { id: "submitonly", name: "Submit-Only" }
  // { id: "user", name: "Normal User" }
];

// Roles a Lite Admin (#73) is NOT allowed to hand out (would be privilege
// escalation). The User form filters these out for a Lite Admin; the backend
// rejects them regardless.
export const privilegedRoleIds = ["admin", "agency"];
